import { render, staticRenderFns } from "./portfolioInfo.vue?vue&type=template&id=327ee288&scoped=true&"
import script from "./portfolioInfo.vue?vue&type=script&lang=ts&"
export * from "./portfolioInfo.vue?vue&type=script&lang=ts&"
import style0 from "./portfolioInfo.vue?vue&type=style&index=0&id=327ee288&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327ee288",
  null
  
)

export default component.exports